import { Controller } from "@hotwired/stimulus"

// Renders a live "elapsed since" counter (e.g. "0:42", "1:05:03") into the
// element, based on an ISO timestamp value. Generic — used by the BoQ import
// processing states, reusable anywhere.
export default class extends Controller {
  static values = { since: String }

  connect() {
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const start = Date.parse(this.sinceValue)
    if (Number.isNaN(start)) return

    const totalSeconds = Math.max(0, Math.floor((Date.now() - start) / 1000))
    this.element.textContent = this.format(totalSeconds)
  }

  format(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60
    const pad = (value) => String(value).padStart(2, "0")
    return hours > 0 ? `${hours}:${pad(minutes)}:${pad(seconds)}` : `${minutes}:${pad(seconds)}`
  }
}
